import { buildExtrasGuests } from '@features/RoomRateConfigurationWizard/FormSteps/ExtrasStepV2/utils';
import { useTranslations } from '@lang';
import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import type { ExtrasGuest } from 'voyager';
import { PackagesFormValues } from '../../types';

export const usePackageExtrasGuests = (): ExtrasGuest[] => {
  const { t } = useTranslations();
  const { watch } = useFormContext<PackagesFormValues>();
  const guests = watch('guests') ?? [];

  return useMemo(
    () =>
      buildExtrasGuests(
        guests.map(({ guestDetails }) => guestDetails ?? {}),
        (guestNumber) => t('room.guestDetails.guestTitle', { number: guestNumber })
      ),
    [guests, t]
  );
};
